import { createRoot } from 'react-dom/client'
import { Alert, Snackbar } from '@mui/material'
import type { ToastSeverity } from './icons'
import { TOAST_ICON_MAPPING } from './icons'
import { alertSx, snackbarSx } from './styles'

function showToast(message: string, severity: ToastSeverity = 'info', duration = 2000): void {
  const container = document.createElement('div')
  document.body.appendChild(container)
  const root = createRoot(container)

  const handleClose = (): void => {
    root.unmount()
    container.remove()
  }

  root.render(
    <Snackbar
      open={true}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={snackbarSx}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        icon={TOAST_ICON_MAPPING[severity]}
        sx={alertSx}
      >
        {message}
      </Alert>
    </Snackbar>,
  )
}

export { showToast }
